module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Yes</div>\r\n    <div class=\"col-md-5\"><input type=\"text\" value=\"")
    ; __append(escapeFn(booleanYes))
    ; __append("\" name=\"booleanYes\"></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">No</div>\r\n    <div class=\"col-md-5\"><input type=\"text\" value=\"")
    ; __append(escapeFn(booleanNo))
    ; __append("\" name=\"booleanNo\"></div>\r\n</div>")
  }
  return __output;

}